module.exports = __webpack_public_path__ + "static/media/torso-mid-front.46951e61.png";